import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const Breadcrumb = ({ breadcrumbs, textColor = "#64748B", position }) => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    if (path) navigate(path);
  };

  return (
    <div
      className="dd-breadcrumb"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 13,
        fontFamily: "'DM Sans', sans-serif",
        fontWeight: 600,
        color: textColor,
      }}
    >
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.label || index}>
          <div
            onClick={() => breadcrumb.path && handleClick(breadcrumb.path)}
            style={{
              cursor: breadcrumb.path ? "pointer" : "default",
              color: breadcrumb.active ? "#2563EB" : textColor,
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 8px",
              borderRadius: 4,
              transition: "background 0.15s",
            }}
          >
            {breadcrumb.icon && (
              <img src={breadcrumb.icon} alt="" style={{ width: 16 }} />
            )}
            <span>{breadcrumb.label}</span>
          </div>
          {index < breadcrumbs.length - 1 && (
            <img
              src="/assets/arrow-right-chevron.svg"
              alt=""
              style={{ width: 16, height: 16, opacity: 0.6 }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

Breadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
      active: PropTypes.bool,
      icon: PropTypes.string,
    }),
  ).isRequired,
  textColor: PropTypes.string,
  position: PropTypes.string,
};

export default Breadcrumb;
